// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Toast_closeButton__N6t1i"};